import {Injectable} from '@angular/core';
import {Device, DeviceInfo} from '@capacitor/device';
import {StorageManagerGatewayCapacitor} from '../../adapters/real/app-services/storage-manager-gateway-capacitor';
import * as _ from 'lodash';
import {UserModel} from '../../core-logic/models/user/user-model';
import {Router} from '@angular/router';
import {UserGatewayHttp} from '../../adapters/real/api-services/gateways/user-gateway-http';
import {isErrorModel} from '../functions/utilities-functions';
import {NotificationModel} from '../../core-logic/models/notification/notification-model';
import {combineLatest, from, Observable, of} from 'rxjs';
import {NotificationManagerService} from './notification-manager.service';
import {FirebaseMessaging} from '@capacitor-firebase/messaging';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FcmManagerService {
  private deviceInfo: DeviceInfo;
  private currentUser: UserModel;

  constructor(
    private router: Router,
    private userGatewayHttp: UserGatewayHttp,
    private notificationManagerService: NotificationManagerService,
    private storageManagerGatewayCapacitor: StorageManagerGatewayCapacitor) {
  }

  async init() {
    this.deviceInfo = await Device.getInfo();
    if (this.deviceInfo.platform !== 'web') {
      this.storageManagerGatewayCapacitor.getCurrentUser().subscribe( currentUser => {
        if (currentUser && !_.isEmpty(currentUser)) {
          this.currentUser = currentUser;
          this.initFcmListeners();
          this.registerToFcm();
        }
      });
    }
  }

  private initFcmListeners() {

    FirebaseMessaging.addListener('notificationReceived', notification => {
      // console.log('Push notification received: ', notification);
    });

    FirebaseMessaging.addListener('notificationActionPerformed', notification => {
      if(_.has(notification, 'notification.data.data')) {
        const notificationPath = JSON.parse(_.get(notification, 'notification.data.data')) as NotificationModel;
        if (notificationPath.path.internal && notificationPath.targeted && !notificationPath.path.external) {
          from(this.router.navigate([notificationPath.path.internal.value]))
            .subscribe(() => {
              if (!_.isUndefined(notificationPath.targeted.customer) && notificationPath.path.internal.slider_options) {
                this.notificationManagerService.setCustomerSliderOptionsSubject(notificationPath);
              }
              if (!_.isUndefined(notificationPath.targeted.merchant) && notificationPath.path.internal.slider_options) {
                this.notificationManagerService.setMerchantSliderOptionsSubject(notificationPath);
              }
            });
        }
      }
      // console.log('Push notification action performed', notification);
    });
  }

  private updateUserFcmToken(fcmToken: string) {
    this.userGatewayHttp.updateFcmToken(fcmToken).subscribe(updatedUser => {
      if (!isErrorModel(updatedUser)) {
        this.storageManagerGatewayCapacitor.updateCurrentUserFcmToken(fcmToken).subscribe();
      }
    });
  }

  private async registerToFcm() {
    let permissionStatus = await FirebaseMessaging.checkPermissions();
    if (permissionStatus.receive !== 'granted') {
      await FirebaseMessaging.requestPermissions();
    }
    const {token} = await FirebaseMessaging.getToken();
    if (token && (!this.currentUser.fcm_token || this.currentUser.fcm_token !== token)) {
      this.updateUserFcmToken(token);
    }
  }

  havePermission(): Observable<boolean> {
    if (this.deviceInfo.platform === 'web') { return of(true);}
    return combineLatest([
      from(FirebaseMessaging.isSupported()),
      from(FirebaseMessaging.checkPermissions())
    ]).pipe(map(responses => (!(responses[0].isSupported && responses[1].receive !== 'granted'))));
  }
}
